var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 29.3333V5.33332C8.5 4.62608 8.78095 3.9478 9.28105 3.4477C9.78115 2.94761 10.4594 2.66666 11.1667 2.66666H21.8333C22.5406 2.66666 23.2189 2.94761 23.719 3.4477C24.219 3.9478 24.5 4.62608 24.5 5.33332V29.3333H8.5Z",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 16H5.83332C5.12608 16 4.4478 16.281 3.9477 16.781C3.44761 17.2811 3.16666 17.9594 3.16666 18.6667V26.6667C3.16666 27.3739 3.44761 28.0522 3.9477 28.5523C4.4478 29.0524 5.12608 29.3333 5.83332 29.3333H8.49999",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12H27.1667C27.8739 12 28.5522 12.281 29.0523 12.781C29.5524 13.2811 29.8333 13.9594 29.8333 14.6667V26.6667C29.8333 27.3739 29.5524 28.0522 29.0523 28.5523C28.5522 29.0524 27.8739 29.3333 27.1667 29.3333H24.5",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 8H19.1667",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 13.3333H19.1667",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 18.6667H19.1667",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 24H19.1667",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.4822cae904c20ffd8aecda2bcd6e4f7e.svg";
export { ForwardRef as ReactComponent };